import "./subtitle.css"

export default function SubTitle({planetName}){
    return(
        <h5 className="subtitle">{planetName}</h5>
    )
}